import { render } from "./ModalAutoPay.vue?vue&type=template&id=5b1e8fbe"
import script from "./ModalAutoPay.vue?vue&type=script&lang=js"
export * from "./ModalAutoPay.vue?vue&type=script&lang=js"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__